import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { getRouteData } from '@app/helpers';
import { filter, map, startWith, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BottomBarMobileSpaceService {
  private readonly router = inject(Router);

  readonly canSeeBottomBarMobile$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    startWith(null),
    map(() => {
      const data = getRouteData(this.router.routerState.snapshot.root);
      return !!data?.['canSeeBottomBarMobile'];
    }),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  readonly canSeeBottomBarMobile = toSignal(this.canSeeBottomBarMobile$, {
    initialValue: false,
  });
}
